import { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';

import * as actions from './../../../store/actions';
import CommonErrorContent from '../CommonErrorContent/CommonErrorContent';

interface LoginNoAccessProps {
  title: string;
  contentBodyText: string;
  instructionBodyText: string;
  logoutButtonLabel: string;
}

const LoginNoAccess: FunctionComponent<LoginNoAccessProps> = ({ title, contentBodyText, instructionBodyText, logoutButtonLabel }) => {
  const dispatch = useDispatch();

  const handleLogout = () => dispatch(actions.executeLogout());

  return (
    <CommonErrorContent
      title={title}
      subtitle={contentBodyText}
      content={instructionBodyText}
      buttonText={logoutButtonLabel}
      onButtonClick={handleLogout}
    />
  );
};

export default LoginNoAccess;
